<template></template>
<script>
export default {
  mounted() {
    this.$store
      .dispatch("users/deleteUser", this.$route.params.id)
      .then(resp => {
        this.$router.push({ name: "users" });
        this.$notify({
          type: "success",
          message: $t('user.message.successdelete')
        });
      })
      .catch(error => {
        this.$router.push({ name: "users" });
        this.$notify({
          type: "danger",
          message: $t('user.message.errordelete')
        });
      });
  }
};
</script>
<style>
</style>
